import Vue from 'vue'
import Router from 'vue-router'
import { store } from './store/store'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      name: 'base',
      //component: () => import('./views/Home.vue')
      redirect: '/login',
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('./views/Home.vue')
    },
    {
      path: '/announcement',
      name: 'announcement',
      component: () => import('./views/Announcement.vue')
    },
    {
      path: '/document',
      name: 'document',
      component: () => import('./views/Document.vue')
    },
    {
      path: '/booking',
      name: 'booking',
      component: () => import('./views/booking/front.vue'),
      meta: { 
          requiresAuth: true
      },
      children: [
        {
          path: ':school_id',
          name: 'booking-school',
          component: () => import('./views/booking/index.vue'),
          meta: {
              requiresAuth: true
          }
        }
      ],
    },
    {
      path: '/iot_experiment/:school_id',
      name: 'iot_experiment',
      component: () => import('./views/experiment/index.vue'),
      meta: { 
          requiresAuth: true
      },
      children: [
        {
          path: ':experiment/:equipment_id',
          name: 'laboratory',
          component: () => import('./views/experiment/iot_experiment/index.vue'), // Parent router-view,
          meta: { 
              requiresAuth: true
          },
        },
      ],
    },
    {
      path: '/group_experiment/:school_id',
      name: 'group_experiment',
      component: () => import('./views/experiment/index.vue'),
      meta: { 
          requiresAuth: true
      },
      children: [
        {
          path: ':experiment/:equipment_id',
          name: 'group_experiment_lab',
          component: () => import('./views/experiment/group_experiment/index.vue'), // Parent router-view,
          meta: { 
              requiresAuth: true
          },
        },
      ],
    },
    {
      path: '/group_experiment_board',
      name: 'group_experiment_board',
      component: () => import('./views/group_experiment_board/front.vue'),
      meta: { 
          requiresAuth: true
      },
      children: [
        {
          path: ':school_id',
          name: 'group_experiment-school',
          component: () => import('./views/group_experiment_board/index.vue'),
          meta: {
              requiresAuth: true
          },
        }
      ],
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue')
    },
    {
      path: '/logout',
      name: 'logout',
      component: () => import('./views/Logout.vue')
    },
    {
      path: '/management',
      name: 'management',
      component: () => import('./views/management/index.vue'), // Parent router-view
      meta: { 
        requiresAuth: true,
        requiresAdmin: true,
       },
    },
    {
      path: '/management/school',
      name: 'management-school',
      component: () => import('./views/school/index.vue'), // Parent router-view
      meta: { 
        requiresAuth: true,
        requiresAdmin: true,
      },
      children: [
        {
          path: ':school_id',
          name: 'management-school-management',
          component: () => import('./views/school/management.vue'), // Parent router-view
          meta: { requiresAuth: true,
            requiresAdmin: true, },
        }
      ]
    },
    {
      path: '/management/list',
      name: 'management-list',
      component: () => import('./views/list/index.vue'), // Parent router-view
      meta: { requiresAuth: true,
        requiresAdmin: true, },
      children: [
        {
          path: ':school_id',
          name: 'management-list-school',
          component: () => import('./views/school/management.vue'), // Parent router-view
          meta: { requiresAuth: true,
            requiresAdmin: true, },
        }
      ]
    },
    {
      path: '/chart',
      name: 'chart',
      component: () => import('./views/chart.vue'), // Parent router-view
    },
    {
      path: '/404',
      component: () => import('@/views/404'),
      hidden: true
    },
    { path: '*',
      redirect: '/404',
      hidden: true
    },
  ]
})

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
      if ($cookies.get('auth_token') == null) {
        // $cookies.set('after_login', to.fullPath);
          next({
              path: '/login',
              params: { nextUrl: to.fullPath }
          })
      } else {
          // let user = JSON.parse(localStorage.getItem('user'))
          // if(to.matched.some(record => record.meta.is_admin)) {
          //     if(user.is_admin == 1){
          //         next()
          //     }
          //     else{
          //         next({ name: 'userboard'})
          //     }
          // }else {
            if(to.matched.some(record => record.meta.requiresAdmin)) {
              if ($cookies.get('user_level') !="ADMIN" && $cookies.get('user_level') !="INCHARGE") {
                next({
                  path: '/',
                  params: { nextUrl: to.fullPath }
                })
              }
              else {
                next()
              }
            }
            else {
              next();
            }
          // }
      }
  } 
  else {
      next() 
  }
})

export default router
